/**
 * BlogGrid.tsx — Gold Garage Door / Blog Hub · Section 2/4
 * Cream · 6 placeholder blog post cards (replace with real posts as they go live).
 * Each card: image placeholder, title, excerpt, "Read more" link.
 * MOBILE: real <style> media queries.
 * 10WEB AI: keep <style>. Wave dividers intentional — do NOT strip.
 */

const NAVY = "#081438";
const GOLD = "#F5A623";
const GOLD_DARK = "#9A6400";
const INK = "#1A1F2E";
const CREAM = "#FAF7F1";
const POSTS = [{
  slug: "#",
  title: "5 Signs Your Garage Door Spring Is About to Snap",
  cat: "Repairs",
  excerpt: "A broken spring can leave your car trapped. Here's how to spot trouble before it strikes."
}, {
  slug: "#",
  title: "Sectional vs Roller Doors: Which Is Right for Sydney Homes?",
  cat: "Installation",
  excerpt: "Pros, cons and price ranges — a no-nonsense comparison from the crew that installs both."
}, {
  slug: "#",
  title: "How Often Should You Service Your Garage Door?",
  cat: "Maintenance",
  excerpt: "Annual, bi-annual, or only when it squeaks? We break down the real maintenance schedule."
}, {
  slug: "#",
  title: "B&D Controll-A-Door Not Working? Try This First",
  cat: "Brands",
  excerpt: "The most common CAD faults we see across Sydney — and the quick fixes before you call us."
}, {
  slug: "#",
  title: "Why Your Garage Door Remote Stops Working in Cold Weather",
  cat: "Tips",
  excerpt: "Batteries, frequency drift and condensation — the real reasons and easy solutions."
}, {
  slug: "#",
  title: "Garage Door Safety: What Every Sydney Homeowner Needs to Know",
  cat: "Safety",
  excerpt: "Springs under tension, pinch points and auto-reverse — the safety checks that matter."
}];
export default function BlogGrid() {
  return <section id="blog-grid" style={{
    background: CREAM,
    position: "relative",
    overflow: "hidden",
    paddingTop: "4.5rem",
    paddingBottom: "4.5rem"
  }}>
      <style>{`
        .blg-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1.5rem; }
        @media (max-width: 880px) { .blg-grid { grid-template-columns: repeat(2, 1fr); } }
        @media (max-width: 560px) {
          .blg-grid { grid-template-columns: 1fr; }
          #blog-grid { padding-top: 3rem; padding-bottom: 3rem; }
        }
      `}</style>

      <div aria-hidden style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      lineHeight: 0,
      transform: "rotate(180deg)"
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}><path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill={NAVY} /></svg>
      </div>

      <svg aria-hidden style={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      opacity: 0.4,
      pointerEvents: "none",
      mixBlendMode: "multiply"
    }}><filter id="paper-blg"><feTurbulence type="fractalNoise" baseFrequency="0.04" numOctaves="5" stitchTiles="stitch" /><feColorMatrix type="matrix" values="0 0 0 0 0.85, 0 0 0 0 0.82, 0 0 0 0 0.74, 0 0 0 0.08 0" /></filter><rect width="100%" height="100%" filter="url(#paper-blg)" /></svg>

      <div style={{
      maxWidth: "1150px",
      margin: "0 auto",
      padding: "0 1.5rem",
      position: "relative",
      zIndex: 1
    }}>
        <div className="blg-grid">
          {POSTS.map((p, i) => <a key={i} href={p.slug} style={{
          textDecoration: "none",
          display: "block"
        }}>
              <article style={{
            background: "#fff",
            border: `1px solid ${GOLD}22`,
            borderRadius: "14px",
            overflow: "hidden",
            boxShadow: "0 6px 22px rgba(8,20,56,0.05)",
            height: "100%",
            display: "flex",
            flexDirection: "column"
          }}>
                {/* image placeholder */}
                <div style={{
              height: "160px",
              background: `linear-gradient(135deg, ${NAVY}, #1a2f5e)`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}>
                  <span style={{
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontWeight: 800,
                fontSize: "2.5rem",
                color: `${GOLD}25`
              }}>GG</span>
                </div>
                <div style={{
              padding: "1.25rem",
              flexGrow: 1,
              display: "flex",
              flexDirection: "column"
            }}>
                  <span style={{
                fontFamily: "'Manrope', sans-serif",
                fontSize: "0.68rem",
                fontWeight: 700,
                letterSpacing: "0.12em",
                color: GOLD_DARK,
                textTransform: "uppercase",
                marginBottom: "0.5rem"
              }}>{p.cat}</span>
                  <h3 style={{
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontWeight: 800,
                fontSize: "1.05rem",
                color: NAVY,
                lineHeight: 1.3,
                marginBottom: "0.5rem"
              }}>{p.title}</h3>
                  <p style={{
                fontFamily: "'Manrope', sans-serif",
                fontSize: "0.88rem",
                color: INK,
                lineHeight: 1.55,
                flexGrow: 1
              }}>{p.excerpt}</p>
                  <span style={{
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontWeight: 700,
                fontSize: "0.85rem",
                color: GOLD_DARK,
                marginTop: "0.75rem"
              }}>Read more →</span>
                </div>
              </article>
            </a>)}
        </div>
      </div>

      <div aria-hidden style={{
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      lineHeight: 0
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}><path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill={NAVY} /></svg>
      </div>
    </section>;
}